/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../../components/Containers';
import HeaderTitle from '../../../../../components/HeaderTitle';
import ButtonOptionSystem from '../../../../../components/NovoSistema/ButtonOptionSystem';
import { SelectSystemHeader } from '../../../../../components/NovoSistema/SelectSystemHeader';
import AnaliseCusto from './AnaliseCusto';
import AnaliseDespesa from './AnaliseDespesa';
import AnaliseReceita from './AnaliseReceita';
import DreConsolidado from './DreConsolidado';
import DreEmpresa1 from './DreEmpresa1';
import DreEmpresa2 from './DreEmpresa2';
import Indicadores from './Indicadores';
import RbEbitdaLl from './RbEbitdaLl';
import ReceitaVsCusto from './ReceitaVsCusto';

export default function TemplateBudgetActualForecast() {
  const [systemOption, setSystemOption] = useState('');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Dashboard - Budget | Actual | Forecast" linkIcon="/images/icons/speedometer.svg" />
        <SelectSystemHeader>
          <ButtonOptionSystem
            systemName="Análise Receita"
            color=""
            border="#70309F"
            active={systemOption === 'Análise Receita' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Análise Custo"
            color=""
            border="#70309F"
            active={systemOption === 'Análise Custo' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Análise Despesa"
            color=""
            border="#70309F"
            active={systemOption === 'Análise Despesa' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Receita vs Custo"
            color=""
            border="#70309F"
            active={systemOption === 'Receita vs Custo' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Indicadores"
            color=""
            border="#70309F"
            active={systemOption === 'Indicadores' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="RB | EBITDA | LL"
            color=""
            border="#70309F"
            active={systemOption === 'RB | EBITDA | LL' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="DRE Consolidado"
            color=""
            border="#70309F"
            active={systemOption === 'DRE Consolidado' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="DRE Empresa 1"
            color=""
            border="#70309F"
            active={systemOption === 'DRE Empresa 1' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="DRE Empresa 2"
            color=""
            border="#70309F"
            active={systemOption === 'DRE Empresa 2' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
        </SelectSystemHeader>
        {systemOption === 'Análise Receita' && <AnaliseReceita />}
        {systemOption === 'Análise Custo' && <AnaliseCusto />}
        {systemOption === 'Análise Despesa' && <AnaliseDespesa />}
        {systemOption === 'Receita vs Custo' && <ReceitaVsCusto />}
        {systemOption === 'Indicadores' && <Indicadores />}
        {systemOption === 'RB | EBITDA | LL' && <RbEbitdaLl />}
        {systemOption === 'DRE Consolidado' && <DreConsolidado />}
        {systemOption === 'DRE Empresa 1' && <DreEmpresa1 />}
        {systemOption === 'DRE Empresa 2' && <DreEmpresa2 />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
